import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: '#7833FF',
    fontSize: 26,
    fontWeight: 'bold',
    fontFamily: 'Lato',
    padding: '10px 0px',
  },
  moreInfo: {
    color: '#424242',
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: 16,
  },
}));
